<!--
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-08-01 10:52:49
 * @LastEditors: 牛字杰 niuzijie@.jtexpress
 * @LastEditTime: 2022-08-01 11:01:27
 * @FilePath: \jmssa-vip-customers-front\src\views\problem-shipment\components\importDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-dialog
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('导入')"
      :close-on-click-modal="false"
      :visible.sync="visible"
      width="900px"
      top="0px"
    >
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    showDialog() {
      console.log(111111111111)
      this.visible = true
    }
  }
}
</script>

